"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _toggleMenuItem = _interopRequireDefault(require("./component/toggleMenuItem"));
var _Anchor = _interopRequireDefault(require("../../../Atoms/Anchor"));
var _common = require("../../../../core/utils/common");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var MobileChildNavListItems = function MobileChildNavListItems(props) {
  var _useState = (0, _react.useState)(false),
    expand = _useState[0],
    setExpand = _useState[1];
  var links = props.links,
    customClass = props.customClass,
    _props$icons = props.icons,
    up = _props$icons.up,
    down = _props$icons.down;
  var getLinkTitle = function getLinkTitle(url, title) {
    return url ? _react.default.createElement(_Anchor.default, {
      to: (0, _common.urlSanitize)(url),
      title: title,
      className: "cmp-mobile-navigation__group__container--link"
    }, title) : _react.default.createElement("div", {
      className: "cmp-mobile-navigation__group__container--text"
    }, title);
  };
  var getList = function getList() {
    var _links$title = links.title,
      title = _links$title === void 0 ? '' : _links$title,
      _links$url = links.url,
      url = _links$url === void 0 ? '' : _links$url;
    return links && title ? _react.default.createElement("li", {
      className: customClass,
      key: title,
      id: "nav-" + title,
      "data-locator": title
    }, _react.default.createElement("div", {
      className: "cmp-mobile-navigation__group__container " + customClass
    }, getLinkTitle(url, title))) : null;
  };
  if (Array.isArray(links)) {
    return links.map(function (items, index) {
      var key = "type-" + index;
      return _react.default.createElement(MobileChildNavListItems, (0, _extends2.default)({}, props, {
        links: items,
        key: key
      }));
    });
  }
  if (links.hasOwnProperty('secondaryChildren')) {
    // Nested Objects
    if (Object.keys(links).length > 1) {
      var title = links.title,
        url = links.url;
      return _react.default.createElement("li", {
        key: title,
        id: "nav-" + title,
        "data-locator": title,
        className: customClass
      }, _react.default.createElement("div", {
        className: "cmp-mobile-navigation__group__container " + customClass + " " + (expand && 'is-expanded'),
        onClick: function onClick() {
          return setExpand(!expand);
        }
      }, _react.default.createElement(_toggleMenuItem.default, {
        url: url,
        title: title,
        customClass: customClass,
        expand: expand,
        up: up,
        down: down,
        showIcon: true
      })), _react.default.createElement("ul", {
        className: "cmp-mobile-navigation__group-wrapper secondary " + (expand ? 'is-expanded' : '')
      }, _react.default.createElement(MobileChildNavListItems, (0, _extends2.default)({}, props, {
        links: links['secondaryChildren'],
        customClass: "secondary"
      }))));
    } // Secondary Links

    return _react.default.createElement(MobileChildNavListItems, (0, _extends2.default)({}, props, {
      links: links['secondaryChildren'],
      customClass: "primary"
    }));
  }
  return getList();
};
var _default = MobileChildNavListItems;
exports.default = _default;
module.exports = exports["default"];